<template>
	<div>
		<template>
			<div class="panel-body no-padding">
				<div class="table-responsive no-overflow">
					<table-editable-list :columns="columns"
																:show-select="false"
																:show-actions="false"
																:tableClass="{'margin-bottom-0': true, 'no-border': true}">
						<template slot="data-row">
							<template v-for="(course, idx) in department.COURSES">
								<table-list-row :key="`course_${course.COURSE_DESC}`"
																:columns="columns"
																:rowdata="course"
																:rowIndex="idx"
																:showActions="false">
								</table-list-row>
							</template>
						</template>
					</table-editable-list>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		props: {
			description: {
				type:			String,
				default:	''
			},
			department: {
				type:			Object,
				required:	true
			}
		},
		computed: {
			columns() {
				return [
					{
						heading: this.$t( 'MAIN_CONTENT.CourseRequestForms.courseTitle' ),
						key: 'DISPLAY_TITLE',
						customCol: 'courseTitle'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.CourseRequestForms.credits' ),
						key: 'CREDITS',
						customCol: 'credits'
					}
				];
			}
		},
		components: {
			TableEditableList,
			TableListRow
		}
	}
</script>
